<template>
	<!-- -->
	<div id="fullscreenElement" @contextmenu.prevent="preventRightClick">
		<div class="p-0">
			<div
				v-if="Loaderstatus && !isMediaSubmitted && !isVideoSubmitted"
				class="relativeclass"
			>
				<div class="testscreen-spinnerstyle">
					<Spinner />
				</div>
			</div>
			<template>
				<div class="test-main-container">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<div class="test-headtext mb-0" style="width: 45%">
							<div class="text-truncate mr-2" @click="show = true">
								{{ testDetails.name }}
							</div>
						</div>
						<div style="width: 30%" class="ml-4">
							<div
								:class="timeinsecondsfornotificationfunc.style"
								class="test-timerdiv-active d-flex"
								v-if="testDetails.config.dispDuration"
							>
								<div class="d-flex align-items-center ml-3">
									<img
										v-if="
											timeinsecondsfornotificationfunc.imageName == 'whitetimer'
										"
										src="../assets/newimgs/whitetimer1.svg"
										alt
									/>
									<img v-else src="../assets/newimgs/whitetimer1.svg" alt />
								</div>
								<div class="d-flex timer-txt-new align-items-center ml-2 mr-4">
									<span>{{ testTimer }}</span>
								</div>
							</div>
						</div>
						<div
							class="d-flex align-items-center justify-content-end bluebtns"
							style="width: 25%; gap: 5px"
						>
							<b-button
								v-if="isSandbox"
								:disabled="previewLinks.length == 0"
								class="px-5"
								variant="primary"
								@click="
									previewLinks.length != 0 && $bvModal.show('previewModal')
								"
								>Preview Links</b-button
							>
							<b-button
								class="px-5"
								v-if="testDetails.config.includeEndTest"
								variant="primary"
								@click="isSandbox ? (finishtestmodal = true) : endTestPost()"
								>Finish Test</b-button
							>
						</div>
					</div>
					<div v-if="isSandbox" class="editor-height">
						<iframe
							:src="sandboxUrl"
							frameborder="0"
							class="w-100 h-100"
						></iframe>
					</div>
					<div
						class="test-left-container w-100"
						style="padding: unset;"
						v-if="showCommunicationPage && !isSandbox"
					>
						<div
							v-if="!communicationQues.questionBody.questionMedia"
							class="d-flex w-100 h-92 p-5"
						>
							<div
								class="w-100 d-flex text-center flex-column align-items-center justify-content-center"
							>
								<section class="question-title">
									<div
										class="d-flex align-items-center justify-content-center"
										style="gap:8px;"
									>
										<img
											v-if="audioAnswered"
											src="@/assets/green-tick-light.svg"
											alt
										/>
										<h2 class="text-h2 fs-16 grayish-text">
											Question {{ communicationQues.questionNo }}:
										</h2>
									</div>
									<div
										class="font-primary fw-700 fs-20 mt-2"
										v-html-safe="communicationQues.questionBody.question"
									></div>
								</section>
								<div class="video-card margin4416px">
									<div v-if="videoLoading" class="video-black-screen">
										<div class="white-bar-loader">
											<div v-for="i in 8" :key="i"></div>
										</div>
										<div class="text-white-1">Loading...</div>
									</div>
									<video
										ref="camera"
										style="object-fit: cover;"
										id="selfieCam"
										playsinline
										muted
										:src="videoURL"
									></video>
								</div>
								<div class="record-section">
									<div class="wa-recorder">
										<div
											:style="{
												background:
													audioBlob || isRecording ? '#20639B14' : '#F4F4F4',
											}"
											class="audio-bar"
										>
											<section
												v-if="showPlayPause"
												@click="togglePlay"
												class="pointer"
											>
												<img
													v-if="!isPlaying"
													src="@/assets/communication/play.svg"
												/>
												<img v-else src="@/assets/communication/pause.svg" />
											</section>

											<div ref="waveform" class="waveform"></div>

											<div v-if="showDuration" class="timer font-primary">
												{{ formattedTime }}
											</div>
										</div>
										<h2
											v-if="!audioBlob && !isRecording"
											class="mt-2 text-h2 fs-12 fw-500 error-red font-secondary"
										>
											Please click on mic icon to record answer
										</h2>
										<!-- <h2
											v-else-if="recordingType == 'answered'"
											class="mt-2 text-h2 fs-14 fw-500 fresh-green font-secondary"
										>
											You have already answered for this question!
										</h2> -->
										<img
											@click="toggleRecording"
											class="pointer"
											v-if="!audioBlob && !isRecording"
											src="@/assets/communication/record.svg"
										/>
										<div v-else class="position-relative">
											<b-button
												:disabled="
													(!isRecording && finishUploadCalled) || submittingTest
												"
												@click="
													(!isRecording && finishUploadCalled) || submittingTest
														? ''
														: toggleRecording()
												"
												class="btn-red d-flex align-items-center mt-3 w-160px justify-content-center"
											>
												<!-- <img
												v-if="recordingType == 'answered'"
												src="@/assets/reset-white.svg"
												alt
												class="mr-2"
											/> -->
												<h2
													:class="!isRecording && finishUploadCalled && 'hide'"
													class="fs-13 font-secondary pure-white text-h2 font-secondary"
												>
													{{
														audioBlob && !isRecording
															? "Retake Recording"
															: isRecording
															? "Stop Recording"
															: "Start Recording"
													}}
												</h2>
												<div
													v-if="!isRecording && finishUploadCalled"
													class="loader-pos-rec"
												>
													<Loader />
												</div>
											</b-button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<main v-else class="main-question-box h-92 justify-content-center">
							<article class="question-box w-100">
								<div class="d-flex" style="gap:20px;">
									<div
										class="question-img"
										v-if="
											isVideo(
												communicationQues.questionBody.questionMediaType
											) ||
												isImage(
													communicationQues.questionBody.questionMediaType
												)
										"
									>
										<Media
											v-if="
												isVideo(
													communicationQues.questionBody.questionMediaType
												)
											"
											:kind="'video'"
											:isMuted="false"
											:src="communicationQues.questionBody.questionMedia"
											:autoplay="false"
											:controls="true"
											:loop="true"
											class="comm-image-preview"
										></Media>
										<img
											v-else
											:src="communicationQues.questionBody.questionMedia"
										/>
									</div>
									<div class="w-100">
										<Media
											v-if="
												isAudio(
													communicationQues.questionBody.questionMediaType
												)
											"
											:kind="'audio'"
											:isMuted="false"
											:src="communicationQues.questionBody.questionMedia"
											:autoplay="false"
											:controls="true"
											:loop="true"
											class="w-50 mb-2 mt-1"
											style="background: #f1f3f4;border-radius: 6px;height: 36px;"
										></Media>
										<div class="d-flex align-items-center" style="gap:8px;">
											<img
												v-if="audioAnswered"
												src="@/assets/green-tick-light.svg"
												alt
											/>
											<h2 class="text-h2 fs-16 grayish-text">
												Question {{ communicationQues.questionNo }}:
											</h2>
										</div>

										<div
											class="font-primary fw-700 fs-20 mt-2"
											v-html-safe="communicationQues.questionBody.question"
										></div>
										<!-- <h1 class="text-h2 fw-700 fs-20 dark-gray mt-3">Qorem ipsum dolor sit amet, consectetur
                                adipiscing elit.
										Nunc vulputate libero et velit interdum, ac aliquet odio mattis.</h1>-->
									</div>
								</div>
							</article>
							<article class="screen-section mt-44">
								<div class="d-flex align-items-center" style="gap:20px;">
									<div class="screen-box ">
										<div v-if="videoLoading" class="video-black-screen">
											<div class="white-bar-loader">
												<div v-for="i in 8" :key="i"></div>
											</div>
											<div class="text-white-1">Loading...</div>
										</div>
										<video
											ref="camera"
											style="object-fit: cover;"
											id="selfieCam"
											playsinline
											muted
										></video>
									</div>
									<div
										class="text-center d-flex flex-column align-items-center justify-content-center"
										style="width: calc(100% - 500px);"
									>
										<div
											:style="{
												background:
													audioBlob || isRecording ? '#20639B14' : '#F4F4F4',
											}"
											class="audio-bar w-100"
										>
											<section
												v-if="showPlayPause"
												@click="togglePlay"
												class="pointer"
											>
												<img
													v-if="!isPlaying"
													src="@/assets/communication/play.svg"
												/>
												<img v-else src="@/assets/communication/pause.svg" />
											</section>

											<div ref="waveform" class="waveform"></div>
											<div v-if="showDuration" class="timer font-primary">
												{{ formattedTime }}
											</div>
										</div>
										<h2
											v-if="!audioBlob && !isRecording"
											class="mt-3 text-h2 fs-12 fw-500 error-red font-secondary"
										>
											Please click on mic icon to record answer
										</h2>
										<!-- <h2
											v-else-if="recordingType == 'answered'"
											class="mt-3 text-h2 fs-14 fw-500 fresh-green font-secondary"
										>
											You have already answered for this question!
										</h2> -->
										<img
											@click="toggleRecording"
											class="pointer mt-3"
											v-if="!audioBlob && !isRecording"
											src="@/assets/communication/record.svg"
										/>
										<div v-else class="position-relative">
											<b-button
												:disabled="
													(!isRecording && finishUploadCalled) || submittingTest
												"
												@click="
													(!isRecording && finishUploadCalled) || submittingTest
														? ''
														: toggleRecording()
												"
												class="btn-red d-flex align-items-center mt-3 w-160px justify-content-center"
											>
												<img
													v-if="recordingType == 'answered'"
													src="@/assets/reset-white.svg"
													alt
													class="mr-2"
												/>
												<h2
													:class="!isRecording && finishUploadCalled && 'hide'"
													class="fs-13 font-secondary pure-white text-h2 font-secondary"
												>
													{{
														recordingType == "answered"
															? "Reset Answer"
															: audioBlob && !isRecording
															? "Retake Recording"
															: isRecording
															? "Stop Recording"
															: "Start Recording"
													}}
												</h2>
												<div
													v-if="!isRecording && finishUploadCalled"
													class="loader-pos-rec"
												>
													<Loader />
												</div>
											</b-button>
										</div>
									</div>
								</div>
							</article>
						</main>
						<hr class="my-0" />
						<div class="p-3 pl-4 pr-4 d-flex justify-content-between bluebtns">
							<b-button variant="outline-primary" @click="checkAndGoBack()"
								>Back to Sections</b-button
							>
							<div class="position-relative">
								<b-button
									variant="primary"
									@click="
										showSubmitAudio && !finishUploadCalled && !videoSubFail
											? uploadAudio()
											: ''
									"
									:disabled="
										!showSubmitAudio || finishUploadCalled || videoSubFail
									"
								>
									<span
										:class="submittingTest && 'hide'"
										class="font-secondary fw-600 fs-13"
									>
										Submit Answer</span
									>
								</b-button>
								<div v-if="submittingTest" class="loader-pos-sub">
									<Loader />
								</div>
							</div>
						</div>
					</div>
					<div class="d-flex" v-else-if="!tryQuestionvariable && !isSandbox">
						<div
							class="test-left-container p-0 relativeclass"
							:class="openCodingSection ? 'p-0' : ''"
						>
							<div v-if="!openCodingSection" class>
								<div class="p-3">
									<SectionFilling />
								</div>
								<hr class="my-0" />
								<div class="test-footer p-3">
									<div class="d-flex">
										<div style="width: 20%" class="bluebtns">
											<b-button
												variant="outline-primary"
												@click="previous(), scrollToBottom()"
												v-if="!prevBtn"
												>Previous Section</b-button
											>
										</div>
										<div
											v-if="selectedSection.sectionName != 'programming'"
											style="width: 60%"
											class="d-flex align-items-center justify-content-center"
										>
											<div
												class="d-flex align-items-center justify-content-center pagination-icon"
												:class="
													lastQuestionIndex == 0 ||
													lastQuestionIndex == noOfQues
														? 'nxticon-disable'
														: 'nxticon'
												"
											>
												<b-button
													id="prevbtnb"
													variant="outline"
													@click="prevPag(), scrollToBottom()"
													:disabled="
														lastQuestionIndex == 0 ||
															lastQuestionIndex == noOfQues
													"
												>
													<img
														src="../assets/icons/testscreen/previcon.svg"
														alt
													/>
												</b-button>
											</div>
											<div class="test-pagetext ml-3 mr-3">
												Page {{ noPage }} / {{ noOfPages }}
											</div>
											<div
												class="d-flex align-items-center justify-content-center"
												:class="
													noPage == noOfPages
														? 'nxticon-disable'
														: 'nxticon pagination-icon'
												"
											>
												<b-button
													id="nxtbtnb"
													variant="outline"
													:disabled="noPage == noOfPages"
													@click="nextPag(), scrollToBottom()"
												>
													<img
														src="../assets/icons/testscreen/nxticon.svg"
														alt
													/>
												</b-button>
											</div>
										</div>
										<div
											style="width: 20%"
											class="d-flex justify-content-end bluebtns"
										>
											<b-button
												@click="nextSection(), scrollToBottom()"
												v-if="!nextBtn"
												variant="primary"
												>Next Section</b-button
											>
										</div>
									</div>
								</div>

								<video id="proctor" autoplay muted></video>
								<canvas
									id="proctoring"
									width="200"
									height="150"
									hidden
								></canvas>
							</div>
							<div v-else class="h-100">
								<TakeQuestions />
							</div>
						</div>
						<div class="test-right-container relativeclass">
							<div class="test-rightside-text d-flex justify-content-center">
								Overview
							</div>
							<div>
								<ProgressBar />
							</div>
						</div>
					</div>
					<div v-else-if="!isSandbox">
						<TryQuestion />
					</div>
				</div>
			</template>
			<b-modal
				id="cantopentab"
				size="md"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				:no-close-on-esc="true"
			>
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Alert
				</div>
				<div
					@click="$bvModal.hide('cantopentab')"
					class="modalcloseicon-camacc pointer"
				>
					<img
						class="rotate-on-hover"
						src="../assets/newimgs/closeicon.svg"
						alt
					/>
				</div>
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img src="../assets/newui-img/test-screen/fullscn-alert.svg" alt />
					</div>
					<div class="line2-txt mt-4">
						Please note that you cannot open a new tab or window while taking
						the test.
					</div>
					<div class="bluebtns mt-5">
						<b-button
							variant="primary"
							class="pl-4 pr-4"
							@click="$bvModal.hide('cantopentab')"
							>Okay</b-button
						>
					</div>
				</div>
			</b-modal>
			<b-modal
				id="refreshmodal"
				size="md"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				:no-close-on-esc="true"
			>
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Alert
				</div>
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img src="../assets/newui-img/test-screen/fullscn-alert.svg" alt />
					</div>
					<div class="line2-txt mt-4">
						Oops! Something went wrong with the network. Please refresh the page
						to try again.
					</div>
					<div class="bluebtns mt-5">
						<b-button variant="primary" class="pl-4 pr-4" @click="refreshPage()"
							>Refresh</b-button
						>
					</div>
				</div>
			</b-modal>
			<b-modal
				id="cantnavigate"
				size="md"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				:no-close-on-esc="true"
			>
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Alert
				</div>
				<div
					@click="$bvModal.hide('cantnavigate')"
					class="modalcloseicon pointer"
				>
					<img
						class="rotate-on-hover"
						src="../assets/newimgs/closeicon.svg"
						alt
					/>
				</div>
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img src="../assets/newimgs/alerticon.svg" alt />
					</div>
					<div class="newmodal-body-content mt-4">
						Please note you cannot navigate while you are taking test.
					</div>
					<div class="bluebtns mt-5">
						<b-button
							variant="primary"
							class="pl-4 pr-4"
							@click="$bvModal.hide('cantnavigate')"
							>Okay</b-button
						>
					</div>
				</div>
			</b-modal>
			<b-modal
				id="cantendtest"
				size="md"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				:no-close-on-esc="true"
			>
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Alert
				</div>
				<div
					@click="$bvModal.hide('cantendtest')"
					class="modalcloseicon pointer"
				>
					<img
						class="rotate-on-hover"
						src="../assets/newimgs/closeicon.svg"
						alt
					/>
				</div>
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img src="../assets/newimgs/alerticon.svg" alt />
					</div>
					<div class="newmodal-body-content mt-4" v-html-safe="requiredText">
						<!-- Please note you are not supposed to end the test untill all the
						required questions has been answered. -->
					</div>
					<div class="bluebtns mt-5">
						<b-button
							variant="primary"
							class="pl-4 pr-4"
							@click="$bvModal.hide('cantendtest')"
							>Okay</b-button
						>
					</div>
				</div>
			</b-modal>
			<b-modal
				id="finishtestmodal"
				size="md"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				:no-close-on-esc="true"
			>
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Alert
				</div>
				<div
					@click="!Loaderstatus && $bvModal.hide('finishtestmodal')"
					:class="['modalcloseicon', Loaderstatus ? 'disabled-icon' : 'pointer']"
				>
					<img
						class="rotate-on-hover"
						src="../assets/newimgs/closeicon.svg"
						alt
					/>
				</div>
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img src="../assets/newimgs/testscreen/testscreenmodal.svg" alt />
					</div>
					<div class="newmodal-body-content-ques mt-4">
						Are you sure you want to finish the test ?
					</div>
					<div class="newmodal-body-content mt-4">
						Please note this action cannot be undone
					</div>
					<div class="bluebtns mt-5">
						<b-button
							variant="outline-primary"
							class="mr-3"
							:disabled="Loaderstatus"
							@click="$bvModal.hide('finishtestmodal')"
							>Cancel</b-button
						>
						<b-button
							variant="primary"
							class="pl-4 pr-4"
							style="min-width: 110px; min-height: 38px;"
							:disabled="Loaderstatus"
							@click="(Loaderstatus = true), finishTestStopt()"
						>
							<span v-if="!Loaderstatus">Finish Test</span>
							<div v-else class="finish-test-loader">
								<Loader />
							</div>
						</b-button>
					</div>
				</div>
			</b-modal>
			<b-modal
				id="latermodal"
				size="md"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				:no-close-on-esc="true"
			>
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Alert check!
				</div>
				<div
					@click="!Loaderstatus && $bvModal.hide('latermodal')"
					:class="['modalcloseicon', Loaderstatus ? 'disabled-icon' : 'pointer']"
				>
					<img
						class="rotate-on-hover"
						src="../assets/newimgs/closeicon.svg"
						alt
					/>
				</div>
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img src="../assets/newimgs/testscreen/testscreenmodal.svg" alt />
					</div>
					<div
						class="newmodal-body-content mt-4"
						v-html-safe="laterModalText"
					></div>
					<div class="bluebtns mt-5">
						<b-button
							class="mr-3 pl-4 pr-4"
							variant="outline-primary"
							:disabled="Loaderstatus"
							@click="hideLaterModal()"
							>Cancel</b-button
						>
						<b-button
							variant="primary"
							class="pl-4 pr-4"
							style="min-width: 110px; min-height: 38px;"
							:disabled="Loaderstatus"
							@click="(Loaderstatus = true), finishtestlater()"
						>
							<span v-if="!Loaderstatus">Finish Test</span>
							<div v-else class="finish-test-loader">
								<Loader />
							</div>
						</b-button>
					</div>
				</div>
			</b-modal>
			<b-modal
				id="alertmodal"
				size="md"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				:no-close-on-esc="true"
			>
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Alert
				</div>

				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img src="../assets/newui-img/test-screen/fullscn-alert.svg" alt />
					</div>
					<div class="line2-txt mt-4">This test requires full screen mode.</div>
					<div class="bluebtns mt-4">
						<b-button variant="primary" class="px-5" @click="fullScreenMode()"
							>Okay</b-button
						>
					</div>
				</div>
			</b-modal>
			<b-modal
				id="sandbox-force-stopped"
				class="sandbox-modal"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
			>
				<div class="d-flex align-items-center p-3">
					<div>
						<img src="../assets/mobile-newUI-imgs/new-warning-icon.svg" alt />
					</div>
					<div class="flex-1 pl-3">
						<div class="d-flex justify-content-between">
							<div class="mobileScreen-modal-head">Test has been stopped.</div>
						</div>
						<div class="mobileScreen-modal-subhead mt-2 pr-4">
							Your test session has been terminated by the test creator. You
							will no longer be able to proceed with this test.
						</div>
					</div>
				</div>

				<section
					class="d-flex align-items-center-w-100 gap-3 px-4 pb-3 justify-content-end mt-3"
				>
					<b-button class="grey-btn" @click="goToLogin()">Okay</b-button>
				</section>
			</b-modal>
			<b-modal
				id="notsubWarning"
				size="md"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				v-model="notSubWarning"
				:no-close-on-esc="true"
			>
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Alert
				</div>
				<div @click="notSubWarning = false" class="modalcloseicon pointer">
					<img
						class="rotate-on-hover"
						src="../assets/newimgs/closeicon.svg"
						alt
					/>
				</div>
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img src="../assets/newimgs/alerticon.svg" alt />
					</div>
					<div class="newmodal-body-content mt-4">
						Please note you cannot navigate while you are taking test.
					</div>
					<div class="bluebtns mt-5">
						<b-button
							variant="primary"
							class="pl-4 pr-4"
							@click="$bvModal.hide('cantnavigate')"
							>Okay</b-button
						>
					</div>
				</div>
			</b-modal>
			<b-modal
				id="sandbox-reset"
				class="sandbox-modal"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
			>
				<div class="d-flex align-items-center p-3">
					<div>
						<img src="../assets/mobile-newUI-imgs/new-warning-icon.svg" alt />
					</div>
					<div class="flex-1 pl-3">
						<div class="d-flex justify-content-between">
							<div class="mobileScreen-modal-head">Test has been reset.</div>
						</div>
						<div class="mobileScreen-modal-subhead mt-2 pr-4">
							This test has been reset by the creator. Unsaved code has been
							lost. Please log in again to continue the test.
						</div>
					</div>
				</div>

				<section
					class="d-flex align-items-center-w-100 gap-3 px-4 pb-3 justify-content-end mt-3"
				>
					<b-button class="grey-btn" @click="goToLogin()">Okay</b-button>
				</section>
			</b-modal>
			<PreviewLinksModal :previewLinks="previewLinks" />
		</div>
		<div v-if="latermodal" class="testscreen-custom-modal">
			<div class="testscreen-modal-content-2">
				<div
					v-if="isVideoSubmitted && isMediaSubmitted"
					class="relativeclass h-100"
				>
					<div
						class="d-flex align-items-center justify-content-center"
						style="height: 80%"
					>
						<Spinner type="FinishTest" />
						<div class="loader-text-2">
							"Please do not reload or close the page. Your test is being
							submitted."
						</div>
					</div>
				</div>
				<template v-else>
					<div
						class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
					>
						Alert
					</div>

					<div
						class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
					>
						<div>
							<img
								src="../assets/newui-img/test-screen/finish-testscreen.svg"
								alt
							/>
						</div>
						<div
							class="line1-txt mt-4 loader-text"
							v-html-safe="laterModalText"
						></div>
						<div class="bluebtns mt-5">
						<b-button
							class="mr-3 pl-4 pr-4"
							variant="outline-primary"
							:disabled="Loaderstatus"
							@click="latermodal = false"
							>Cancel</b-button
						>
						<b-button
							variant="primary"
							class="pl-4 pr-4"
							style="min-width: 110px; min-height: 38px;"
							:disabled="Loaderstatus"
							@click="(Loaderstatus = true), finishtestlater()"
						>
							<span v-if="!Loaderstatus">Finish Test</span>
							<div v-else class="finish-test-loader">
								<Loader />
							</div>
						</b-button>
						</div>
					</div>
				</template>
			</div>
		</div>
		<div v-if="finishtestmodal" class="testscreen-custom-modal">
			<div class="testscreen-modal-content">
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Alert !
				</div>
				<div
					@click="!Loaderstatus && (finishtestmodal = false)"
					:class="['modalcloseicon', Loaderstatus ? 'disabled-icon' : 'pointer']"
				>
					<img
						class="rotate-on-hover"
						src="../assets/newimgs/closeicon.svg"
						alt
					/>
				</div>
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img src="../assets/newimgs/testscreen/testscreenmodal.svg" alt />
					</div>
					<div class="line1-txt mt-4">
						Are you sure you want to finish the test ?
					</div>
					<div class="line2-txt">Please note this action cannot be undone</div>
					<div class="bluebtns mt-5">
						<b-button
							variant="outline-primary"
							class="mr-3"
							:disabled="Loaderstatus"
							@click="finishtestmodal = false"
							>Cancel</b-button
						>
						<b-button
							variant="primary"
							class="pl-4 pr-4"
							style="min-width: 110px; min-height: 38px;"
							:disabled="Loaderstatus"
							@click="(Loaderstatus = true), finishTestStopt()"
						>
							<span v-if="!Loaderstatus">Finish Test</span>
							<div v-else class="finish-test-loader">
								<Loader />
							</div>
						</b-button>
					</div>
				</div>
			</div>
		</div>
		<div v-if="cantendtest" class="testscreen-custom-modal">
			<div class="testscreen-modal-content">
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Alert
				</div>
				<div @click="cantendtest = false" class="modalcloseicon-camacc pointer">
					<img
						class="rotate-on-hover"
						src="../assets/newimgs/closeicon.svg"
						alt
					/>
				</div>
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img src="../assets/newui-img/test-screen/fullscn-alert.svg" alt />
					</div>
					<div class="line2-txt mt-4 w-75" v-html-safe="requiredText">
						<!-- Please note you are not supposed to end the test untill all the
						required questions has been answeredd. -->
					</div>
					<div class="bluebtns mt-5">
						<b-button
							variant="primary"
							class="px-5"
							@click="cantendtest = false"
							>Okay</b-button
						>
					</div>
				</div>
			</div>
		</div>
		<div v-if="cantnavigate || notSubWarning" class="testscreen-custom-modal">
			<div class="testscreen-modal-content">
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Alert !
				</div>
				<div
					@click="(notSubWarning = false), (cantnavigate = false)"
					class="modalcloseicon pointer"
				>
					<img
						class="rotate-on-hover"
						src="../assets/newimgs/closeicon.svg"
						alt
					/>
				</div>
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img src="../assets/newui-img/test-screen/fullscn-alert.svg" alt />
					</div>
					<div class="line2-txt mt-4">
						{{
							notSubWarning && isRecording
								? "Recording is in progress. Are you sure you want to go back? Your current recording will be lost."
								: notSubWarning
								? "You have a recorded answer that’s not submitted. Do you want to go back or proceed anyway?"
								: "Please note you cannot navigate while you are taking test."
						}}
					</div>
					<div class="bluebtns mt-5" :class="!cantnavigate && 'd-flex gap-24'">
						<b-button
							v-if="notSubWarning"
							variant="outline-primary"
							class="px-5"
							@click="notSubWarning = false"
							>Cancel</b-button
						>
						<b-button
							variant="primary"
							class="px-5"
							@click="notSubWarning ? handleBack() : (cantnavigate = false)"
							>{{ notSubWarning ? "Continue" : "Okay" }}</b-button
						>
					</div>
				</div>
			</div>
		</div>
		<div v-if="cameramodal" class="testscreen-custom-modal">
			<div class="testscreen-modal-content-camacc">
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					Allow Camera Access
				</div>
				<div @click="startStream()" class="modalcloseicon-camacc pointer">
					<img
						class="rotate-on-hover"
						src="../assets/newimgs/closeicon.svg"
						alt
					/>
				</div>
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div class="newmodal-body-content">
						You cannot able to continue with test untill you turn on camera
					</div>
					<div class="mt-5 mb-3 img-shadow">
						<img src="../assets/newui-img/test-screen/cam-access-img.svg" alt />
					</div>
					<div class="newmodal-body-content mt-4">
						Once you enable the camera, please reload the page
					</div>
					<img
						class="mt-4 img-shadow"
						style="width: 83%"
						src="../assets/images/step3.svg"
						alt
					/>

					<div class="bluebtns mt-5">
						<b-button variant="primary" class="px-5" @click="startStream()"
							>Okay</b-button
						>
					</div>
				</div>
			</div>
		</div>
		<div v-if="agentmodal && !endingTest" class="testscreen-custom-modal">
			<div class="testscreen-modal-content-installagent">
				<div
					class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
				>
					The agent is still not working. Please do the below steps
				</div>
				<div
					@click="agentCheckForWindows()"
					class="modalcloseicon-camacc pointer"
				>
					<img
						class="rotate-on-hover"
						src="../assets/newimgs/closeicon.svg"
						alt
					/>
				</div>

				<div class="mt-2 step-subtext" style="font-size: medium">
					1. Go to windows and search “Hire3x Proctoring Agent”. And allow all
					the permissions to install it again. (If installed already do the
					below step)
				</div>
				<div class="mt-2">
					<img src="../assets/newimgs/Agent/Windows/agentCheck1.png" alt />
				</div>

				<div class="mt-2 step-subtext" style="font-size: medium">
					2. The application will appear in the “System tray” if it was
					installed correctly. And right-click on the application in the System
					tray and select Start service.
				</div>
				<div class="mt-2">
					<img src="../assets/newimgs/Agent/Windows/agentCheck2.png" alt />
				</div>

				<div
					class="bluebtns d-flex align-items-center justify-content-center mt-3"
				>
					<b-button
						variant="primary"
						class="px-5"
						@click="agentCheckForWindows()"
						>Okay</b-button
					>
				</div>
			</div>
		</div>
		<div
			v-if="notificationmodal"
			class="notification d-flex justify-content-between align-items-center mr-2"
			:class="timeinsecondsfornotificationfunc.style"
		>
			<div style="color: black" class="ml-2">Total Time Remaining:</div>
			<div style="margin-top: 1px">{{ testTimer | formatTime }}</div>
			<div class="pointer mr-2 close-notify">
				<img
					@click="closeNotification()"
					src="../assets/newimgs/closeicon.svg"
					alt
				/>
			</div>
		</div>
		<div
			v-if="stream && !cameramodal"
			class="stream-preview-dock"
			:class="{ 'stream-preview-collapsed': streamCollapsed }"
		>
			<div class="screen-box stream-preview">
				<video ref="floatingStream" autoplay playsinline muted></video>
			</div>
			<div @click="toggleStreamCollapse">
				<div v-if="streamCollapsed" class="stream-preview-tab">
					<div class="stream-preview-tab-text">
						Recording
					</div>
					<img
						src="@/assets/recording-dot.gif"
						class="stream-preview-dot"
						alt="Recording"
					/>
				</div>
				<div class="stream-preview-tab-collapsed" v-else>
					<img
						src="@/assets/monitor-close-arrow.svg"
						class="stream-collapse-icon"
						alt="Collpase"
					/>
				</div>
			</div>
		</div>
		<Internet />
		<b-toaster name="monitor-toaster"></b-toaster>
	</div>
</template>

<script>
import TakeQuestions from "./codingTest/TakeQuestions.vue";
import TryQuestion from "./codingTest/TryQuestion.vue";
import Media from "@dongido/vue-viaudio";
import { isImage, isVideo, isAudio } from "@/checkFileType.js";
import {
	stopTestAgent,
	endTestPost,
	postExtensionLog,
	postMarking,
	posttimer,
	CheckAgentService,
	submitTestForSandbox,
	updateTestForSandbox,
	getPreviewLink,
	getSectionStats,
	postSectionStats,
	triggerTranscodeJob,
} from "../apiFunction.js";
import { createMultipartSession, pickMimeType } from "../services/s3MultipartUpload.js";
import Internet from "./fixedcomponents/Internet.vue";
import SocketioService from "../services/socketio.service";
import Spinner from "../components/fixedcomponents/Spinner.vue";
import SectionFilling from "../components/SectionFilling.vue";
import ProgressBar from "../components/ProgressBar.vue";
import { mapGetters } from "vuex";
import { io } from "socket.io-client";
import postMessageUrl from "../mixins/postMessageUrl";
import PreviewLinksModal from "./modals/PreviewLinksModal.vue";
import { trackAssessmentEnded } from '@/utils/posthogHelpers';
import eventBus from "@/utils/eventBus.js";
import CommuTestMixin from "../mixins/commutestmixin";
import FaceDetectionMonitor from "../services/faceDetectionMonitor";
let proctorSocket = null;

export default {
	name: "TestScreen",
	mixins: [postMessageUrl, CommuTestMixin],
	components: {
		Spinner,
		SectionFilling,
		ProgressBar,
		TakeQuestions,
		TryQuestion,
		Internet,
		PreviewLinksModal,
		Media,
	},
	data() {
		return {
			isMediaSubmitted: false,
			isVideoSubmitted: false,
			endingTest: false,
			notificationmodal: false,
			timeinsecondsfornotification: null,
			internetDisconnected: false,
			len: 0,
			force: 0,
			laterModalText: "",
			requiredText: "",
			mediaRecorderScreen: null,
			Loaderstatus: false,
			endTestRes: false,
			latermodal: false,
			cantendtest: false,
			cantnavigate: false,
			finishtestmodal: false,
			cameramodal: false,
			agentmodal: false,
			timerEnd: false,
			stream: null,
			screenstream: null,
			timerFix: null,
			items: [],
			socketInterval: null,
			testtimerInterval: null,
			agentInterval: null,
			postMessageinterval: null,
			posttimerinterval: null,
			getPreviewLinkInterval: null,
			previewLinks: [],

			cvsvideorecord: null,
			cameraSession: null,   // s3MultipartUpload session for camera
			screenSession: null,   // s3MultipartUpload session for screen share
			cameraFileID: null,    // fileID stored after camera session completes
			cameraKey: null,       // S3 key stored after camera session completes
			screenFileID: null,    // fileID stored after screen share session completes

			showRefresh: false,
			sectionTimings: {},
			currentSectionStartTime: null,
			areStatsLoaded: false,
			faceDetectionMonitor: null,
			streamCollapsed: false,
			faceDetectionIncident: {
				// Track the currently active "incident" (e.g., NO_FACE / MULTIPLE_FACES)
				// and only toast once after it persists for 2 seconds.
				flag: null,
				startedAtMs: 0,
				notified: false,
			},
			faceMonitoringToastId: "face-monitoring-alert",
		};
	},
	filters: {
		formatTime(value) {
			let dateString = value;
			let dateArray = dateString.split(":");
			let hour = dateArray[0]; // '05'
			let minute = dateArray[1]; // '01'
			let second = dateArray[2]; // '01'
			let finalTime = "";
			if (hour != "00") {
				finalTime = finalTime + hour + " Hour and ";
			}
			if (minute != "00") {
				finalTime = finalTime + minute + " Minute and ";
			}
			if (second != "00") {
				finalTime = finalTime + second + " Second ";
			}
			return finalTime;
		},
	},
	computed: {
		...mapGetters("sandboxVUEX", {
			isSandbox: "isSandbox",
			sandboxUrl: "getSandboxUrl",
			sandboxID: "getSandboxID",
		}),
		...mapGetters("codingVUEX", {
			tryQuestionvariable: "gettryQuestion",
			openCodingSection: "getopenCodingSection",
		}),
		...mapGetters("testVUEX", {
			questionData: "getQuestionData",
			sectionDetails: "getSectionDetails",
			selectedSection: "getSelectedSection",
			screenShareEnabled: "getscreenShareEnabled",
			getallAnswers: "getallAnswer",
			totalanswered: "gettotalanswered",
		}),
		...mapGetters("sectionVUEX", {
			testDetails: "getTestDetails",
			userID: "getUserID",
			uuid: "getUUID",
			nextBtn: "getNextBtn",
			prevBtn: "getPrevBtn",
			licenseKey: "getlicensekey",
			sectionId: "getsectionId",
			testtimeleft: "gettesttimeleft",
			testtaken: "gettesttaken",
			testTimer: "gettesttimeleftintimeformat",
			userDetails: "getUserDetails",
			selectedCodingSectionIndex: "getSelectedCodingSectionIndex",
		}),
		...mapGetters("questionVUEX", {
			noOfQues: "getNoOfQues",
			lastQuestionIndex: "getLastQuestionIndex",
			noPage: "getNoPage",
			noOfPages: "getNoOfPages",
			pageItem: "getPageItem",
		}),
		timeinsecondsfornotificationfunc() {
			if (this.testDetails.config.includeTimeNotifics) {
				let totaltime = Number(this.testDetails.config.testDuration) * 60;
				if (this.timeinsecondsfornotification <= (5 / 100) * totaltime) {
					return { style: "notify-red-class", imageName: "" };
				} else if (
					this.timeinsecondsfornotification <=
					(25 / 100) * totaltime
				) {
					return { style: "notify-orange-class", imageName: "" };
				} else if (
					this.timeinsecondsfornotification <=
					(50 / 100) * totaltime
				) {
					return { style: "notify-yellow-class", imageName: "" };
				} else {
					return { style: "notify-green-class", imageName: "" };
				}
			} else {
				return { style: "", imageName: "whitetimer" };
			}
		},
		notificationmodalalert() {
			if (this.testDetails.config.includeTimeNotifics) {
				let totaltime = Number(this.testDetails.config.testDuration) * 60;
				if (this.timeinsecondsfornotification == (5 / 100) * totaltime) {
					return true;
				} else if (
					this.timeinsecondsfornotification ==
					(25 / 100) * totaltime
				) {
					return true;
				} else if (
					this.timeinsecondsfornotification ==
					(50 / 100) * totaltime
				) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		currentTrackingId() {
			if (this.selectedSection && this.selectedSection.sectionID) {
				if (
					this.selectedSection.sectionName === "programming" &&
					this.openCodingSection &&
					this.selectedCodingSectionIndex !== null
				) {
					return `${this.selectedSection.sectionID}_prog_${this.selectedCodingSectionIndex}`;
				}
				return this.selectedSection.sectionID;
			}
			return null;
		},
	},

	beforeUnmount() {
		SocketioService.disconnect();
		this.stopFaceDetectionMonitoring(true);
	},
	beforeDestroy() {
		this.stopAllTimers();
		if (this.wavesurfer) this.wavesurfer.destroy();
		this.stopTimer();
		this.postSectionStats();
		window.removeEventListener("beforeunload", this.handleBeforeUnload);
		document.removeEventListener(
			"visibilitychange",
			this.handleVisibilityChange
		);
		this.stopFaceDetectionMonitoring(true);
	},
	created() {
		// Removed immediate init - wait for testDetails watcher
		// this.getSectionStats();

		window.addEventListener("message", (event) => {
			if (
				event.data.type === "SCRIPT_READY" &&
				this.testDetails.config.allowExtension
			) {
				window.postMessage(
					{
						type: "START_TEST",
						text: "START_TEST",
						testType: this.isSandbox ? "Sandbox" : "Normal",
					},
					this.url
				);
			}
		});
		history.pushState(location.href, null, location.href);
		window.onpopstate = function() {
			history.go(1);
		};
		if (localStorage.getItem("testFinished")) {
			this.$router.push({ name: "TestClosed" });
		} else {
			this.agentInterval = setInterval(() => {
				this.validationForWindowsLinuxMac();
			}, 5000);
			this.$store.commit("testVUEX/storeresponseAvail", true);
			if (this.getallAnswers.length > 0) {
				this.$store.dispatch("testVUEX/saveAnswer", "recall");
			}
			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				userID: this.userID,
				attemptNo: this.testDetails.attemptNo,
			};
			if (!this.isSandbox) {
				this.$store.dispatch("testVUEX/getTestResponse", payload);
			}
			delete payload.userID;
			this.$store.dispatch("testVUEX/testCount", payload);
			this.timeinsecondsfornotification = localStorage.getItem("timer");
		}
		this.initializeSockets();
	},
	mounted() {
		eventBus.$on("show-communication", this.showCommunication);
		// this.initWaveSurfer();
		if (this.isSandbox) {
			this.getPreviewLinkInterval = setInterval(async () => {
				try {
					const res = await getPreviewLink(this.sandboxID);
					this.previewLinks = res.data.data.previewLinks;
				} catch (error) {
					console.log(error);
				}
			}, 2000);
		}
		if (!localStorage.getItem("testFinished")) {
			this.Loaderstatus = true;
			localStorage.setItem("testStarted", true);
			window.addEventListener("beforeunload", this.handleBeforeUnload);
			console.log(this.postMessageinterval);
			this.postMessageinterval = setInterval(function() {
				let data = { type: "EXTENSION_ENABLED", text: "EXTENSION_ENABLED" };
				window.postMessage(data, this.url);
			}, 3000);
			window.addEventListener("message", this.windowListenerFunc, false);
			if (!this.isSandbox) {
				document.addEventListener(
					"fullscreenchange",
					this.handleFullscreenChange
				);
				document.addEventListener(
					"mozfullscreenchange",
					this.handleFullscreenChange
				);
				document.addEventListener(
					"webkitfullscreenchange",
					this.handleFullscreenChange
				);
				document.addEventListener(
					"MSFullscreenChange",
					this.handleFullscreenChange
				);
			}
			SocketioService.setupSocketConnection();
			window.addEventListener("online", function() {
				window.onbeforeunload = null;
				window.location.reload();
			});
			if (this.testDetails.config.enableCamera) {
				this.startStream();
				// Create a MutationObserver to listen for changes in camera permission
				const observer = new MutationObserver(() => {
					this.startStream();
				});

				// Observe the 'state' of camera permission
				navigator.permissions
					.query({ name: "camera" })
					.then((permissionStatus) => {
						permissionStatus.onchange = () => {
							observer.disconnect(); // Disconnect the observer to avoid memory leaks
							this.startStream();
						};
					});
			}
			if (
				this.testDetails.config.enableScreenShare &&
				!this.screenShareEnabled
			) {
				this.startscreenshare();
				console.log("screen shar here e");
			}

			this.movePage();
			this.Timer();
			this.scrollToBottom();
			this.$store.commit("sectionVUEX/prevnextbtnstatus", this.sectionId);
			this.disableCopy();
			this.$bvModal.show("alertmodal");
			window.addEventListener("offline", () => {
				clearInterval(this.socketInterval);
				clearInterval(this.testtimerInterval);
			});
		}
		this.currentSectionStartTime = Date.now();
		// Refresh recovery is handled entirely by the backend's initiate endpoint.
		// No client-side checkRefresh needed.

		// Add visibility change listener (Critical for Mobile/iOS where beforeunload is flaky)
		document.addEventListener("visibilitychange", this.handleVisibilityChange);
	},

	watch: {
		// NEW: Watch for testDetails to become available before initializing stats
		"testDetails.testID": {
			handler(val) {
				if (val) {
					console.log("TestID available, initializing stats...", val);
					this.initializeStats();
				}
			},
			immediate: true,
		},
		getSectionDetails(newValue, oldValue) {
			if (newValue != oldValue) {
				this.sectionDetails = newValue;
			}
		},
		notificationmodalalert() {
			this.notificationmodal = true;
			setTimeout(() => {
				this.notificationmodal = false;
			}, 5000);
		},
		selectedSection(newVal, oldVal) {
			console.log(newVal, oldVal);
			// Logic moved to currentTrackingId watcher
		},
		currentTrackingId(newVal, oldVal) {
			if (oldVal) {
				this.recordSectionTime(oldVal);
			}
			this.currentSectionStartTime = Date.now();
			this.postSectionStats();
		},
	},

	methods: {
		showFaceMonitoringToast(message) {
			this.$bvToast.toast(message, {
				id: this.faceMonitoringToastId,
				toaster: "monitor-toaster",
				title: "Face monitoring alert",
				solid: true,
				noAutoHide: true,
				noCloseButton: true,
				headerClass: "danger-toast-headerclass",
				bodyClass: "toast-bodyclass",
				toastClass: "",
			});
		},
		hideFaceMonitoringToast() {
			if (!this.faceMonitoringToastId) return;
			try {
				setTimeout(() => {
					this.$bvToast.hide(this.faceMonitoringToastId);
				}, 2000);
			} catch (e) {
				console.log(e);
			}
		},
		resetFaceDetectionIncident() {
			if (this.faceDetectionIncident.notified) {
				this.hideFaceMonitoringToast();
			}
			this.faceDetectionIncident.flag = null;
			this.faceDetectionIncident.startedAtMs = 0;
			this.faceDetectionIncident.notified = false;
		},
		handleFaceMonitoringIncident(primaryFlag) {
			// Group "face not properly detected" into one incident so we don't
			// re-toast when switching between different non-compliance flags.
			const otherFaceIssueFlags = [
				"NO_FACE",
				"FACE_CLIPPED",
				"OFF_CENTER",
				"OUTSIDE_ROI",
			];

			const incidentFlag =
				primaryFlag === "MULTIPLE_FACES"
					? "MULTIPLE_FACES"
					: otherFaceIssueFlags.includes(primaryFlag)
					? "OTHER_FACE_ISSUES"
					: null;

			// If the issue cleared (or changed to something else), stop notifying.
			if (!incidentFlag) {
				this.resetFaceDetectionIncident();
				return;
			}

			// New incident: start timing.
			if (this.faceDetectionIncident.flag !== incidentFlag) {
				// Hide old toast immediately when switching to a different incident type.
				if (this.faceDetectionIncident.notified) {
					this.hideFaceMonitoringToast();
				}
				this.faceDetectionIncident.flag = incidentFlag;
				this.faceDetectionIncident.startedAtMs = performance.now();
				this.faceDetectionIncident.notified = false;
				return;
			}

			// Same incident persists: toast once after it has lasted 2 seconds.
			if (this.faceDetectionIncident.notified) return;
			if (performance.now() - this.faceDetectionIncident.startedAtMs >= 2000) {
				if (incidentFlag === "OTHER_FACE_ISSUES") {
					this.showFaceMonitoringToast(
						"Please ensure your face is clearly visible and centered in the camera."
					);
				} else if (incidentFlag === "MULTIPLE_FACES") {
					this.showFaceMonitoringToast(
						"Multiple faces detected. Please ensure only you are in the camera view."
					);
				}
				this.faceDetectionIncident.notified = true;
			}
		},
		toggleStreamCollapse() {
			this.streamCollapsed = !this.streamCollapsed;
		},
		startMonitoringStream(stream) {
			this.$nextTick(() => {
				if (!stream) return;
				if (!this.faceDetectionMonitor) {
					this.faceDetectionMonitor = new FaceDetectionMonitor();
				}
				this.faceDetectionMonitor.start({
					videoElement: this.$refs.floatingStream,
					onUpdate: ({ primaryFlag }) => {
						this.handleFaceMonitoringIncident(primaryFlag);
					},
				});
			});
		},
		stopFaceDetectionMonitoring(destroy = false) {
			if (!this.faceDetectionMonitor) return;
			if (destroy) {
				this.faceDetectionMonitor.destroy();
				this.faceDetectionMonitor = null;
				return;
			}
			this.faceDetectionMonitor.stop();
		},
		isImage,
		isVideo,
		isAudio,
		stopAllTimers() {
			clearInterval(this.socketInterval);
			clearInterval(this.testtimerInterval);
			clearInterval(this.agentInterval);
			clearInterval(this.posttimerinterval);
			clearInterval(this.getPreviewLinkInterval);
		},
		handleVisibilityChange() {
			if (document.visibilityState === "hidden") {
				console.log("App backgrounded (visibility hidden), saving stats...");
				this.postSectionStats();
			}
		},
		initializeStats() {
			// Initialize from LocalStorage
			const storedTimings = localStorage.getItem(
				`sectionTimings_${this.testDetails.testID}`
			);
			if (storedTimings) {
				try {
					this.sectionTimings = JSON.parse(storedTimings);
					console.log("Loaded local stats:", this.sectionTimings);
				} catch (e) {
					console.error("Failed to parse stored timings", e);
				}
			}
			// Fetch from server
			this.getSectionStats();
		},
		async getSectionStats() {
			try {
				let payload = {
					topicID: this.testDetails.topicID,
					testID: this.testDetails.testID,
					groupID: this.testDetails.groupID,
					candidateID: this.userID,
					attemptNo: this.testDetails.attemptNo,
					licenseKey: this.licenseKey,
				};
				const res = await getSectionStats(payload);
				console.log(res);
				if (res.status == 200 && res.data.data) {
					// The backend likely returns the array structure we sent (sectionStats).
					// We need to convert it back to the sectionTimings map { sectionId: totalTimeMs }
					// Check if it wrapped in sectionStats or direct array
					const statsArray = res.data.data.sectionStats || res.data.data;

					if (Array.isArray(statsArray)) {
						const timings = {};
						statsArray.forEach((stat) => {
							let key = stat.sectionID;
							if (stat.isProgramming) {
								if (
									stat.parentSectionId &&
									stat.programmingIndex !== undefined
								) {
									// Best case: we saved the parent ID and index
									key = `${stat.parentSectionId}_prog_${stat.programmingIndex}`;
								} else {
									// Fallback: Try to find parent by child sectionID (stat.sectionID)
									// This is expensive but necessary if we only have child ID
									if (this.sectionDetails) {
										const parent = this.sectionDetails.find(
											(p) =>
												p.sectionResponse &&
												p.sectionResponse.some(
													(child) => child.sectionID === stat.sectionID
												)
										);
										if (parent) {
											const index = parent.sectionResponse.findIndex(
												(child) => child.sectionID === stat.sectionID
											);
											if (index !== -1) {
												key = `${parent.sectionID}_prog_${index}`;
											}
										}
									}
								}
							}

							if (key && stat.totalTimeMs !== undefined) {
								timings[key] = stat.totalTimeMs;
							}
						});
						this.sectionTimings = timings;
					}
				}

				// Merge with LocalStorage (Priority to max value to avoid data loss)
				const storedTimings = localStorage.getItem(
					`sectionTimings_${this.testDetails.testID}`
				);
				if (storedTimings) {
					try {
						const localTimings = JSON.parse(storedTimings);
						Object.keys(localTimings).forEach((sectionID) => {
							const localVal = localTimings[sectionID] || 0;
							const serverVal = this.sectionTimings[sectionID] || 0;
							this.$set(
								this.sectionTimings,
								sectionID,
								Math.max(localVal, serverVal)
							);
						});
					} catch (e) {
						console.error("Failed to merge local timings", e);
					}
				}

				this.areStatsLoaded = true;
			} catch (error) {
				console.log(error);
			}
		},
		async postSectionStats() {
			// if (!this.areStatsLoaded) return;
			// Record current time before posting to be as accurate as possible
			if (this.currentTrackingId) {
				this.recordSectionTime(this.currentTrackingId);
			}

			try {
				let payload = {
					topicID: this.testDetails.topicID,
					testID: this.testDetails.testID,
					groupID: this.testDetails.groupID,
					candidateID: this.userID,
					attemptNo: this.testDetails.attemptNo,
					licenseKey: this.licenseKey,
					sectionStats: this.getSectionAnalysis(),
				};
				const res = await postSectionStats(payload);
				console.log(res);
			} catch (error) {
				console.log(error);
			}
		},
		refreshPage() {
			window.location.reload();
		},
		async showRefreshModal() {
			this.showRefresh = true;
			if (document.fullscreenElement) {
				await document.exitFullscreen();
			}
			this.$bvModal.show("refreshmodal");
		},
		initializeSockets() {
			if (this.testDetails.config.enableProctoring) {
				proctorSocket = io("wss://imgproctor.hire3x.com");
			}	
			
		},
		// checkRefresh() and uploadPreviousRecord() removed:
		// Refresh recovery is handled entirely by the backend's initiate endpoint.
		// Post-processing webhook calls are deferred to final implementation.
		// See MIGRATION_S3_MULTIPART.md §4 for details.
		goToLogin() {
			this.$router.push({ path: "/", query: { uuid: this.uuid } });
		},
		formatTimeforSocket(seconds) {
			const hours = Math.floor(seconds / 3600) % 24;
			const minutes = Math.floor((seconds % 3600) / 60) % 60;
			const remainingSeconds = seconds % 60;
			return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
				2,
				"0"
			)}:${String(remainingSeconds).padStart(2, "0")}`;
		},
		timeDifference(time) {
			const [hours1, minutes1, seconds1] = time.split(":").map(Number);
			const [hours2, minutes2, seconds2] = this.formatTimeforSocket(
				this.testDetails.config.testDuration * 60
			)
				.split(":")
				.map(Number);
			const totalSeconds1 = hours1 * 3600 + minutes1 * 60 + seconds1;
			const totalSeconds2 = hours2 * 3600 + minutes2 * 60 + seconds2;
			let diff = totalSeconds2 - totalSeconds1;
			if (diff < 0) diff += 24 * 3600;
			const hours = Math.floor(diff / 3600);
			const minutes = Math.floor((diff % 3600) / 60);
			const seconds = diff % 60;
			return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
				2,
				"0"
			)}:${String(seconds).padStart(2, "0")}`;
		},
		hideLaterModal() {
			this.$bvModal.hide("latermodal");
		},
		closeNotification() {
			this.notificationmodal = false;
		},
		async agentCheckForWindows() {
			try {
				let res = await CheckAgentService(this.testDetails.attemptNo);
				if (res.data.data.AGENT_CHECK_RESPONSE) {
					this.agentmodal = false;
				}
				console.log(res.data.data.AGENT_CHECK_RESPONSE);
			} catch (error) {
				console.log(error);
				this.agentmodal = true;
			}
		},

		validationForWindowsLinuxMac() {
			if (this.testDetails.config.allowAgent) {
				this.agentCheckForWindows();
			}
		},

		preventRightClick(event) {
			event.preventDefault();
		},
		async fullScreenMode() {
			try {
				const fullscreenElement = document.getElementById("fullscreenElement");
				let fullscreenPromise;
				if (fullscreenElement.requestFullscreen) {
					fullscreenPromise = fullscreenElement.requestFullscreen();
				} else if (fullscreenElement.mozRequestFullScreen) {
					fullscreenPromise = fullscreenElement.mozRequestFullScreen(); // Firefox
				} else if (fullscreenElement.webkitRequestFullscreen) {
					fullscreenPromise = fullscreenElement.webkitRequestFullscreen(); // Chrome, Safari, Opera
				} else if (fullscreenElement.msRequestFullscreen) {
					fullscreenPromise = fullscreenElement.msRequestFullscreen(); // IE/Edge
				}

				// Wait for it and catch rejections properly
				await fullscreenPromise;
				this.$bvModal.hide("alertmodal");
			} catch (error) {
				console.error("Error entering fullscreen:", error);
				alert("Unable to enter fullscreen mode. Please try again.");
				location.reload();
			}
		},
		handleFullscreenChange() {
			if (
				document.fullscreenElement ||
				document.mozFullScreenElement ||
				document.webkitFullscreenElement ||
				document.msFullscreenElement
			) {
				// We are in full-screen mode
				return;
			} else {
				// We are not in full-screen mode
				this.latermodal = false;
				this.cantendtest = false;
				this.cantnavigate = false;
				this.finishtestmodal = false;
				this.postSectionStats();
				setTimeout(() => {
					console.log("the show refresh", this.showRefresh);
					!this.showRefresh ? this.$bvModal.show("alertmodal") : null;
				}, 1000);
			}
		},
		handleBeforeUnload() {
			this.postSectionStats();
			this.$store.commit("testVUEX/storeScreenShareEnable", false);
			setTimeout(() => {
				window.onbeforeunload = null;
				window.location.reload();
			}, 3000);
			return "Are you sure you want to leave this window?";
		},
		disableCopy() {
			document.onselectstart = () => false;

			if (window.sidebar) {
				document.onmousedown = this.killCopy;
				document.onclick = this.reEnable;
			}
		},
		enableCopy() {
			document.onselectstart = null;
			document.onmousedown = null;
			document.onclick = null;
		},
		killCopy(e) {
			console.log(e);
			return false;
		},
		reEnable() {
			return true;
		},

		movePage() {
			this.items = this.questionData;
			this.$store.commit(
				"questionVUEX/noOfPages",
				Math.ceil(this.items.length / this.testDetails.config.quesPerScreen)
			);
			for (let i in this.questionData) {
				this.items[i].id = i;
			}
			this.$store.commit("questionVUEX/allItem", this.items);
			this.$store.commit(
				"questionVUEX/noOfQues",
				this.testDetails.config.quesPerScreen
			);
			this.$store.commit(
				"questionVUEX/pageItems",
				this.items.slice(0, this.noOfQues)
			);
			this.len = parseInt(this.lastQuestionIndex) + parseInt(this.noOfQues);
			if (this.Loaderstatus) {
				this.Loaderstatus = false;
			}
			this.$store.commit("questionVUEX/lastQuestionIndex", 0);
		},
		nextPag() {
			this.items = this.questionData;
			this.$store.commit("questionVUEX/saveNoPage", "next");
			this.$store.commit("questionVUEX/pageItems", []);
			let lastIndex = this.noOfQues * this.noPage;
			let firstindex = lastIndex - this.noOfQues;

			this.$store.commit("questionVUEX/lastQuestionIndex", lastIndex);
			this.len = parseInt(this.lastQuestionIndex) + parseInt(this.noOfQues);

			this.$store.commit(
				"questionVUEX/pageItems",
				this.items.slice(firstindex, lastIndex)
			);
		},
		prevPag() {
			this.items = this.questionData;
			this.$store.commit("questionVUEX/saveNoPage", "prev");
			let lastIndex = this.noOfQues * this.noPage;
			let firstindex = lastIndex - this.noOfQues;
			this.$store.commit("questionVUEX/lastQuestionIndex", lastIndex);
			this.len = this.len - parseInt(this.noOfQues);
			this.$store.commit("questionVUEX/pageItems", []);
			this.$store.commit(
				"questionVUEX/pageItems",
				this.items.slice(firstindex, lastIndex)
			);
		},
		nextSection() {
			this.$store.commit("questionVUEX/saveNoPage", "set");
			let selectedSection = this.selectedSection.sectionID;
			this.$store.commit("sectionVUEX/saveTabIndex", "next");
			let index1;
			for (let i in this.sectionDetails) {
				if (this.sectionDetails[i].sectionID === selectedSection) {
					let index = parseInt(i);
					index1 = index + 1;
					this.$store.commit("sectionVUEX/prevnextbtnstatus", index1);
				}
			}
			this.$store.commit(
				"testVUEX/saveSelectedSection",
				this.sectionDetails[index1]
			);
			setTimeout(() => {
				document
					.querySelector(".selected-section-progress")
					.scrollIntoView({ behaviour: "smooth", align: true });
			}, 100);
			this.movePage();
		},
		previous() {
			this.$store.commit("questionVUEX/saveNoPage", "set");
			let selectedSection = this.selectedSection.sectionID;
			this.$store.commit("sectionVUEX/saveTabIndex", "prev");
			let index1;
			for (let i in this.sectionDetails) {
				if (this.sectionDetails[i].sectionID === selectedSection) {
					let index = parseInt(i);
					index1 = index - 1;
					this.$store.commit("sectionVUEX/prevnextbtnstatus", index1);
				}
			}
			this.$store.commit(
				"testVUEX/saveSelectedSection",
				this.sectionDetails[index1]
			);
			setTimeout(() => {
				document
					.querySelector(".selected-section-progress")
					.scrollIntoView({ behaviour: "smooth", align: true });
			}, 100);
			this.movePage();
		},
		scrollToBottom() {
			if (
				!this.isSandbox &&
				this.selectedSection.sectionName != "programming"
			) {
				this.$nextTick(() => {
					document
						.getElementById(
							"ques" +
								this.pageItem[0].questionKey +
								this.selectedSection.sectionID
						)
						.scrollIntoView({ behaviour: "smooth", align: true });
				});
			}
		},
		closefinishtest() {
			this.finishtestmodal = false;
		},
		async finishtestlater() {
			//it should check if all the chunks uploadded or not
			this.force = 1;
			// await Promise.all([this.flushFinalChunk(), this.mediaFlushFinalChunk()]);
			this.stopTestBtn();
		},
		closefinishtestlater() {
			this.latermodal = false;
		},
		async startStream() {
			try {
				this.cameramodal = false;
				const stream = await navigator.mediaDevices.getUserMedia({
					audio: true,
					video: { width: { max: 1280 }, height: { max: 720 } },
				});
				this.stream = stream;
				this.attachStreamToPreview(stream);
				this.startrecording(stream);
				this.startMonitoringStream(stream);
			} catch (err) {
				this.cameramodal = true;
				this.stopFaceDetectionMonitoring();
				console.error(`[startStream] getUserMedia error: ${err.name}`);
			}
		},
		attachStreamToPreview(stream) {
			this.$nextTick(async () => {
				const previewVideo = this.$refs.floatingStream;
				if (!previewVideo || !stream) return;
				if (previewVideo.srcObject !== stream) {
					previewVideo.srcObject = stream;
				}
				try {
					await previewVideo.play();
				} catch (error) {
					console.log(error);
				}
			});
		},
		async startscreenshare() {
			try {
				let constraints = {
					audio: false,
					video: {
						displaySurface: "monitor",
						width: { ideal: 1920 },
						height: { ideal: 1080 },
						frameRate: { ideal: 30, max: 60 },
					},
				};
				this.screenstream = await navigator.mediaDevices.getDisplayMedia(
					constraints
				);
			} catch (e) {
				this.startscreenshare();
			}
			if (
				this.screenstream.getVideoTracks()[0].getSettings().displaySurface ==
				"monitor"
			) {
				this.screenstream
					.getVideoTracks()[0]
					.addEventListener("ended", async () => {
						this.$store.commit("testVUEX/storeScreenShareEnable", false);
						try {
							// Stops the recorder; onstop handler calls screenSession.flush()
							await this.mediaFlushFinalChunk();
						} catch (error) {
							console.log(error);
						}
						// No webhook here — this is a mid-session restart, not end-of-test.
						// The post-processing webhook fires once at test end (endTestPost).
						this.startscreenshare();
					});

				if (this.screenstream.getVideoTracks()[0].readyState == "live") {
					this.$store.commit("testVUEX/storeScreenShareEnable", true);
					this.startrecordingScreenShare();
				}
			} else {
				alert("Please select entire screen in screenshare tab");
				window.location.reload();
			}
		},
		async imgProctor() {
			try {
				const stream = await navigator.mediaDevices.getUserMedia({
					video: true,
				});

				const mediaRecorder = new MediaRecorder(stream);

				const videoElement = document.createElement("video");
				videoElement.srcObject = stream;
				videoElement.play();
				await new Promise((resolve) => {
					videoElement.onplay = () => {
						resolve();
					};
				});

				const canvas = document.createElement("canvas");
				const context = canvas.getContext("2d");
				mediaRecorder.ondataavailable = (event) => {
					if (event.data.size > 0) {
						const trackSettings = videoElement.videoWidth
							? {
									width: videoElement.videoWidth,
									height: videoElement.videoHeight,
							  }
							: { width: 640, height: 480 };

						canvas.width = trackSettings.width;
						canvas.height = trackSettings.height;

						context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

						const base64Image = canvas.toDataURL("image/jpeg");
						const payload = {
							src: base64Image,
							time: new Date().toISOString(),
							userid: this.userID,
							groupid: this.testDetails.groupID,
							testid: this.testDetails.testID,
							attemptNo: this.testDetails.attemptNo,
							currentTime: this.timeDifference(this.testTimer),
							testDuration: this.testDetails.config.testDuration,
							topicID: this.testDetails.topicID,
						};
						proctorSocket.emit("image_processing", payload);
					}
				};
				const screenCaptureDuration =
					Number(this.testDetails.config.screenCapture) * 1000;
				mediaRecorder.start(screenCaptureDuration);
			} catch (err) {
				console.error("Error in imgProctor:", err);
			}
		},
		async startrecording(stream) {
			try {
				if (this.testDetails.config.enableProctoring) {
					this.imgProctor();
				}

				// 1. Pick MIME type before constructing MediaRecorder (POC pattern)
				const mimeType = pickMimeType();
				const ext      = mimeType.includes("mp4") ? "mp4" : "webm";
				console.log("[camera] MIME type:", mimeType);

				// 2. Build S3 paths — backend appends a timestamp to the key so every
				//    session lands in a unique S3 object (no merged WebM headers)
				const fileName   = `${this.testDetails.groupID}_${this.testDetails.testID}_${this.userID}_camera.${ext}`;
				const pathPrefix = `processed_streams/production/${this.testDetails.groupID}/${this.testDetails.testID}/${this.userID}/${this.testDetails.attemptNo}/camera/`;
				const bucketPath = `${pathPrefix}${fileName}`;

				// 3. Initiate multipart upload session
				this.cameraSession = createMultipartSession();
				await this.cameraSession.initiate(fileName, bucketPath, pathPrefix, mimeType);

				// 4. MediaRecorder — 1-second timeslices, POC pattern
				this.cvsvideorecord = new MediaRecorder(stream, { mimeType });

				this.cvsvideorecord.ondataavailable = (event) => {
					if (!event.data || event.data.size === 0) return;
					this.cameraSession.feedBlob(event.data);
				};

				this.cvsvideorecord.onstop = async () => {
					await this.cameraSession.flush(
						(result) => {
							this.cameraFileID = result.fileID;
							this.cameraKey    = result.key;
							console.log("[camera] Upload complete:", result);
						},
						(err) => {
							console.error("[camera] Upload failed:", err.message);
							this.showRefreshModal();
						}
					);
				};

				this.cvsvideorecord.start(1000);
				console.log("[camera] Recording started");
			} catch (error) {
				console.error("Error accessing the camera:", error);
			}
		},

		getTestTakenSeconds(totalMinutes, remainingTimeStr) {
			const [hours, minutes, seconds] = remainingTimeStr.split(":").map(Number);
			const remainingSeconds = hours * 3600 + minutes * 60 + seconds;

			const totalSeconds = totalMinutes * 60;
			const takenSeconds = totalSeconds - remainingSeconds;

			return takenSeconds; // Return taken time in seconds
		},
		async startrecordingScreenShare() {
			console.log("[screen] Starting screen share recording");

			// 1. Pick MIME type before constructing MediaRecorder (POC pattern)
			const mimeType = pickMimeType();
			const ext      = mimeType.includes("mp4") ? "mp4" : "webm";
			console.log("[screen] MIME type:", mimeType);

			// 2. Build S3 paths
			const fileName   = `${this.testDetails.groupID}_${this.testDetails.testID}_${this.userID}_screenshare.${ext}`;
			const pathPrefix = `processed_streams/production/${this.testDetails.groupID}/${this.testDetails.testID}/${this.userID}/${this.testDetails.attemptNo}/screenshare/`;
			const bucketPath = `${pathPrefix}${fileName}`;

			// 3. Initiate multipart upload session (independent from cameraSession)
			this.screenSession = createMultipartSession();
			await this.screenSession.initiate(fileName, bucketPath, pathPrefix, mimeType);

			// 4. MediaRecorder — 1-second timeslices, POC pattern
			this.mediaRecorderScreen = new MediaRecorder(this.screenstream, { mimeType });

			this.mediaRecorderScreen.ondataavailable = (event) => {
				if (!event.data || event.data.size === 0) return;
				this.screenSession.feedBlob(event.data);
			};

			this.mediaRecorderScreen.onstop = async () => {
				await this.screenSession.flush(
					(result) => {
						this.screenFileID = result.fileID;
						console.log("[screen] Upload complete:", result);
					},
					(err) => {
						console.error("[screen] Upload failed:", err.message);
						this.showRefreshModal();
					}
				);
			};

			this.mediaRecorderScreen.start(1000);
			console.log("[screen] Recording started");
		},

		flushFinalChunk() {
			// Stop the recorder and wait for the onstop handler (cameraSession.flush)
			// to fully complete before resolving — cameraFileID is set inside it.
			return new Promise((resolve) => {
				if (!this.cvsvideorecord || this.cvsvideorecord.state === "inactive") {
					return resolve();
				}
				const original = this.cvsvideorecord.onstop;
				this.cvsvideorecord.onstop = async (e) => {
					await original.call(this, e);
					resolve();
				};
				this.cvsvideorecord.stop();
			});
		},
		mediaFlushFinalChunk() {
			// Stop the recorder and wait for the onstop handler (screenSession.flush)
			// to fully complete before resolving — screenFileID is set inside it.
			return new Promise((resolve) => {
				if (!this.mediaRecorderScreen || this.mediaRecorderScreen.state === "inactive") {
					return resolve();
				}
				const original = this.mediaRecorderScreen.onstop;
				this.mediaRecorderScreen.onstop = async (e) => {
					await original.call(this, e);
					resolve();
				};
				this.mediaRecorderScreen.stop();
			});
		},
		async windowListenerFunc(event) {
			if (event.source != window) {
				return;
			}
			if (event.data.type == "ACTIVITY_LOG") {
				let check =
					parseInt(this.testDetails.config.testDuration * 60) -
					parseInt(this.timerFix);
				event.data.data.timeStampInVideo = this.convertSecondsToHHMMSS(check);
				let extensionPayload = {
					testID: this.testDetails.testID,
					topicID: this.testDetails.topicID,
					groupID: this.testDetails.groupID,
					userID: this.userID,
					licenseKey: this.licenseKey,
					activity: event.data.data,
					attemptNo: this.testDetails.attemptNo,
					env_type: 3,
				};
				postExtensionLog(extensionPayload);
			}
			if (event.data.type == "EXTENTION_IS_CONFIGRED") {
				let status = {
					type: "EXTENTION_IS_CONFIGRED_RESPONSE",
					permission: this.testDetails.config.allowExtension,
				};
				window.postMessage(status, this.url);
			}
			if (event.data.type == "NEW_TAB") {
				if (event.data.data) {
					this.$bvModal.show("cantopentab");
				}
			}
		},
		async finishTestStopt() {
			if (this.testTimer == "00:00:01") {
				this.force = 1;
				this.timerEnd = true;
			}
			this.timerEnd = false;
			this.stopTestBtn();
		},
		async mediaMultiPartStop() {
			if (!this.testDetails.config.enableScreenShare) {
				return;
			}

			try {
				try {
					await this.mediaFlushFinalChunk();
				} catch (error) {
					console.log(error);
				}

				await new Promise((res) => setTimeout(res, 1000));
			} catch (error) {
				console.error("Error in mediaMultiPartStop:", error);
			}
		},
		async multiPartStop() {
			if (!this.testDetails.config.enableCamera) {
				return;
			}
			try {
				try {
					console.log("Calling flushFinalChunk()");
					await this.flushFinalChunk();
				} catch (error) {
					console.log("This is the error", error);
				}
				await new Promise((res) => setTimeout(res, 1000));
			} catch (error) {
				console.error("Error in multiPartStop:", error);
			}
		},
		async stopTestBtn() {
			this.isVideoSubmitted = true;
			this.isMediaSubmitted = true;
			window.onbeforeunload = null;
			this.handleBack();
			await this.endTestPost();
			setTimeout(() => {
				if (this.endTestRes) {
					if (this.testDetails.config.allowAgent) {
						this.StopAgent();
					}
					SocketioService.socket.emit("endTest", {
						userID: this.userID,
						testID: this.testID,
					});
					let data = { type: "STOP_TEST", text: "STOP_TEST" };
					window.postMessage(data, this.url);
				}
			}, 1000);
		},
		async endTestPost() {
			if (this.isSandbox) {
				this.submitSandboxTest();
			} else {
				try {
					this.endingTest = true;
					this.Loaderstatus = true;
					console.log("the timer end is and force", this.timerEnd, this.force);
					if (this.timerEnd) {
						this.force = 1;
					}
					let data = {
						topicID: this.testDetails.topicID,
						testID: this.testDetails.testID,
						groupID: this.testDetails.groupID,
						timerEnd: this.timerEnd,
						force: this.force,
						attemptNo: this.testDetails.attemptNo,
					};
					console.log("it is here to end the test with the final api call");
					if (this.force == 1) {
						console.log("force is 1, stopping all timers and flushing uploads");
						this.stopAllTimers();
						try {
							// Stop recorders — their onstop handlers call session.flush(),
							// which uploads the final chunk and completes the S3 session.
							// cameraFileID, cameraKey, screenFileID are set inside those handlers.
							await Promise.all([
								this.multiPartStop(),
								this.mediaMultiPartStop(),
							]);

							if (this.$refs.camera) {
								this.$refs.camera.srcObject = null;
								this.$refs.camera.src = null;
							}

							console.log("this.testDetails.config.enableCamera", this.testDetails.config.enableCamera);
							console.log("this.cameraFileID", this.cameraFileID);

							// Post-processing: trigger MediaConvert merge jobs.
							// Camera: carries full downstream notification payload.
							// Screen share: only needs the delimiterKey for merging.
							if (this.testDetails.config.enableCamera && this.cameraFileID) {
								// The webhook must receive the FINAL merged file, not the raw
								// segment. The backend merges all segments and renames the output
								// to a timestamp-stripped .mp4 (e.g. ..._camera.mp4), so derive
								// that path from the timestamped segment key (..._camera_<ts>.webm).
								const mergedCameraUrl = this.cameraKey.replace(/_\d+\.\w+$/, ".mp4");
								triggerTranscodeJob(this.cameraFileID, {
									convert: {
										delimiterKey: "camera",
										url: "https://queue.hire3x.com/post-processing/",
										method: "POST",
										payload: {
											s3Url: mergedCameraUrl,
											email: this.userDetails.email,
											userid: this.userID,
											groupid: this.testDetails.groupID,
											testid: this.testDetails.testID,
											topicID: this.testDetails.topicID,
											testDuration: this.getTestTakenSeconds(
												this.testDetails.config.testDuration,
												localStorage.getItem("remainingtime")
											),
											attemptNo: this.testDetails.attemptNo,
										},
									},
								}).catch((err) => console.error("[camera] triggerTranscodeJob error:", err.message));
							}

							if (this.testDetails.config.enableScreenShare && this.screenFileID) {
								triggerTranscodeJob(this.screenFileID, {
									convert: { delimiterKey: "screenshare" },
								}).catch((err) => console.error("[screen] triggerTranscodeJob error:", err.message));
							}
						} catch (e) {
							console.error("Error during flush operations:", e);
						}
					}
					console.log("callling tehe end test post");
					const res = await endTestPost(data);
					if (res.status == 200) {
						this.endTestRes = true;
						let payload = {};
						payload.topicID = this.testDetails.topicID;
						payload.testID = this.testDetails.testID;
						payload.groupID = this.testDetails.groupID;
						payload.candidateID = this.userID;
						payload.groupID = this.testDetails.groupID;
						payload.attemptNo = this.testDetails.attemptNo;
						console.log("calling the marking");
						const res1 = await postMarking(payload);
						this.finishTest();
						console.log(res1);
					} else if (res.status == 409) {
						this.requiredText = res.data.data.Detail;
						this.endTestRes = false;
						this.cantendtest = true;
					} else if (res.status == 406) {
						this.laterModalText = res.data.data.Detail;
						this.latermodal = true;
					}
				} catch (error) {
					this.Loaderstatus = false;
					if (error.response.status == 409) {
						this.requiredText = error.response.data.data.Detail;
						this.endTestRes = false;
						this.cantendtest = true;
					} else if (error.response.status == 406) {
						this.laterModalText = error.response.data.data.Detail;
						this.latermodal = true;
					} else {
						this.endTestRes = true;
					}
				} finally {
					this.endingTest = false;
				}
			}
		},
		StopAgent() {
			stopTestAgent();
		},
		convertSecondsToHHMMSS(seconds) {
			const hours = Math.floor(seconds / 3600); // 3600 seconds in an hour
			const minutes = Math.floor((seconds % 3600) / 60); // 60 seconds in a minute
			const remainingSeconds = seconds % 60;

			const formattedHours = String(hours).padStart(2, "0");
			const formattedMinutes = String(minutes).padStart(2, "0");
			const formattedSeconds = String(remainingSeconds).padStart(2, "0");

			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		},
		Timer() {
			let timeset = Number(this.testDetails.config.testDuration) * 60;
			let timer = localStorage.getItem("timer");
			this.$store.commit("sectionVUEX/saveremaininigtesttime", timer);
			this.$store.commit("sectionVUEX/testtaken", true);
			SocketioService.socket.emit("message", "start");
			SocketioService.socket.emit("sendtime", {
				timer: timer,
				userID: this.userID,
				testID: this.testDetails.testID,
				duration: timeset,
				attemptNo: this.testDetails.attemptNo,
			});
			// let last = new Date().getTime();
			this.socketInterval = setInterval(() => {
				// let current = new Date().getTime();
				// if (current - last > 15000) {
				// 	console.log("reload");
				// }
				// last = current;

				this.$store.commit(
					"sectionVUEX/saveremaininigtesttime",
					this.testtimeleft
				);
				let time =
					("0" + (Math.floor(this.testtimeleft / 3600) % 24)).slice(-2) +
					":" +
					("0" + (Math.floor(this.testtimeleft / 60) % 60)).slice(-2) +
					":" +
					("0" + (this.testtimeleft % 60)).slice(-2);
				let msg = time;
				localStorage.setItem("remainingtime", msg);
				let remainingtime = localStorage.getItem("remainingtime");
				this.$store.commit(
					"sectionVUEX/saveremaininigtesttimeintimeformat",
					remainingtime
				);
				let array = remainingtime.split(":");
				let seconds =
					parseInt(array[0], 10) * 3600 +
					parseInt(array[1], 10) * 60 +
					parseInt(array[2], 10);
				localStorage.setItem("timer", seconds);
				this.timerFix = seconds;
				this.timeinsecondsfornotification = seconds;
				if (seconds <= 0) {
					clearInterval(this.socketInterval);
					clearInterval(this.testtimerInterval);
					clearInterval(this.agentInterval);
				}
			}, 1000);
			this.testtimerInterval = setInterval(() => {
				const closeTestdt = new Date(this.testDetails.config.closeTestdt);
				const current = new Date();
				const buffer = new Date(closeTestdt.getTime() + 15 * 60000);
				const timeLeftInSeconds = localStorage.getItem("timer");
				if (
					this.testTimer == "00:00:00" ||
					this.testTimer == "00:00:01" ||
					Number(timeLeftInSeconds) <= 0 ||
					current > buffer
				) {
					this.$store.commit(
						"sectionVUEX/saveremaininigtesttimeintimeformat",
						"00:00:00"
					);
					this.timerEnd = true;
					this.force = 1;
					this.stopTestBtn();
					clearInterval(this.socketInterval);
					clearInterval(this.testtimerInterval);
					clearInterval(this.agentInterval);
				}
			}, 1000);
			this.posttimereveryminute();
			this.posttimerinterval = setInterval(async () => {
				this.posttimereveryminute();
			}, 60000);
		},
		posttimereveryminute() {
			this.postSectionStats();
			let timer = localStorage.getItem("timer");
			let payload = {
				testID: this.testDetails.testID,
				timer: parseInt(timer),
				groupID: this.testDetails.groupID,
				attemptNo: this.testDetails.attemptNo,
			};
			let data = {
				topicID: this.testDetails.topicID,
				emailID: this.userDetails.email,
				groupID: this.testDetails.groupID,
				testUUID: this.uuid,
				attemptNo: this.testDetails.attemptNo,
			};
			if (this.isSandbox)
				updateTestForSandbox(data, this.testDetails.testID).catch((err) => {
					if (err.response.status == 423) {
						this.$bvModal.show("sandbox-force-stopped");
					} else if (err.response.status == 404) {
						this.$bvModal.show("sandbox-reset");
					}
				});
			posttimer(payload);
		},
		closechatbotcard() {
			this.chatbotclicked = false;
		},
		chatbotcarddisplay() {
			this.chatbotclicked = true;
		},
		async submitSandboxTest() {
			this.endingTest = true;
			this.Loaderstatus = true;
			try {
				let data = {
					topicID: this.testDetails.topicID,
					emailID: this.userDetails.email,
					groupID: this.testDetails.groupID,
					testUUID: this.uuid,
					attemptNo: this.testDetails.attemptNo,
				};
				const response = await submitTestForSandbox(
					data,
					this.testDetails.testID
				);
				if (response.status == 200) {
					this.endTestRes = true;
					this.finishTest();
				} else {
					throw new Error();
				}
			} catch (error) {
				if (error.response.status == 423) {
					this.finishtestmodal = false;
					this.$bvModal.show("sandbox-force-stopped");
				} else if (error.response.status == 404) {
					this.finishtestmodal = false;
					this.$bvModal.show("sandbox-reset");
				}
			} finally {
				this.Loaderstatus = false;
				this.endingTest = false;
			}
		},
		finishTest() {
			if (this.currentTrackingId) {
				this.recordSectionTime(this.currentTrackingId);
			}
			console.log("Section Analysis:", this.getSectionAnalysis());

			const payload = {
				topicID: this.testDetails.topicID,
				time: new Date().toISOString(),
				userid: this.userID,
				groupid: this.testDetails.groupID,
				testid: this.testDetails.testID,
				attemptNo: this.testDetails.attemptNo,
				currentTime: this.testTimer,
				testDuration: this.testDetails.config.testDuration,
			};
			if (this.testDetails.config.enableProctoring)
				proctorSocket.emit("submit_test", payload);
			window.removeEventListener("beforeunload", this.handleBeforeUnload);
			if (window.opener)
				window.opener.postMessage({ testSubmitted: true }, "*");
			window.onbeforeunload = null;
			this.agentmodal = false;
			clearInterval(this.agentInterval);
			localStorage.removeItem("testStarted");
			localStorage.removeItem("proctertimer");
			localStorage.removeItem(`sectionTimings_${this.testDetails.testID}`);
			localStorage.setItem("testFinished", true);
			if (this.screenstream) {
				const tracks = this.screenstream.getTracks();
				tracks.forEach((track) => track.stop());
			}
			if (this.stream) {
				const tracks = this.stream.getTracks();
				tracks.forEach((track) => track.stop());
			}
			document.removeEventListener(
				"fullscreenchange",
				this.handleFullscreenChange
			);
			if (this.endTestRes) {
				if (this.testDetails.config.allowAgent) {
					this.StopAgent();
				}
				SocketioService.socket.emit("endTest", {
					userID: this.userID,
					testID: this.testID,
				});
				let data = { type: "STOP_TEST", text: "STOP_TEST" };
				window.postMessage(data, this.url);
			}
			if(window.opener){
				window.opener.postMessage({ testSubmitted: true }, "*");
			}
				trackAssessmentEnded({
					email: this.userDetails.email,
					testID: this.testDetails.testID,
					testName: this.testDetails.name,
					jobID: this.testDetails.jobID,
				});
			this.$router.push({
				path: "/finishtest",
			});

			this.Loaderstatus = false;
		},
		recordSectionTime(sectionID) {
			if (!this.currentSectionStartTime) return;
			const now = Date.now();
			const duration = now - this.currentSectionStartTime;
			if (!this.sectionTimings[sectionID]) {
				this.$set(this.sectionTimings, sectionID, 0);
			}
			this.sectionTimings[sectionID] += duration;
			this.currentSectionStartTime = now;

			// Save to LocalStorage
			localStorage.setItem(
				`sectionTimings_${this.testDetails.testID}`,
				JSON.stringify(this.sectionTimings)
			);
		},
		getSectionAnalysis() {
			const analysis = Object.keys(this.sectionTimings).map((key) => {
				const totalTimeMs = this.sectionTimings[key];
				let sectionName = "Unknown";
				let questionCount = 1;
				let sectionID = key;
				let extra = {};

				// Check if it is a programming sub-section
				if (key.includes("_prog_")) {
					const [parentId, subIndex] = key.split("_prog_");
					// Default to parent ID initially
					sectionID = parentId;

					const parentSection = this.sectionDetails.find(
						(s) => s.sectionID === parentId
					);
					if (
						parentSection &&
						parentSection.sectionResponse &&
						parentSection.sectionResponse[subIndex]
					) {
						const childSection = parentSection.sectionResponse[subIndex];
						// Use Child ID as the main sectionID for the payload
						if (childSection.sectionID) {
							sectionID = childSection.sectionID;
						}

						sectionName = `Programming: ${childSection.sectionName}`;
						// questionCount = childSection.sectionResponse ? childSection.sectionResponse.length : 1;
						if (childSection.sectionResponse) {
							questionCount = childSection.sectionResponse.filter(
								(q) => q.answerStatus && q.answerStatus.attempted
							).length;
						} else {
							questionCount = 0;
						}

						extra = {
							programmingIndex: parseInt(subIndex),
							isProgramming: true,
							parentSectionId: parentId, // Save parent ID to help restoration
						};
					} else {
						sectionName = `Programming Sub-section ${parseInt(subIndex) + 1}`;
						extra = {
							programmingIndex: parseInt(subIndex),
							isProgramming: true,
							parentSectionId: parentId,
						};
					}
				} else {
					if (this.sectionDetails) {
						const section = this.sectionDetails.find(
							(s) => s.sectionID === key
						);
						if (section) {
							sectionName = section.sectionName;
							// questionCount = section.sectionResponse ? section.sectionResponse.length : 1;
							if (section.sectionResponse) {
								questionCount = section.sectionResponse.filter(
									(q) => q.answerStatus && q.answerStatus.attempted
								).length;
							} else {
								questionCount = 0;
							}
						}
					}
				}

				if (questionCount === 0) questionCount = 1; // Avoid division by zero

				return {
					sectionID,
					sectionName,
					...extra,
					totalTimeMs,
					totalTimeSeconds: (totalTimeMs / 1000).toFixed(2),
					avgTimePerQuestionMs: totalTimeMs / questionCount,
					avgTimePerQuestionSeconds: (
						totalTimeMs /
						questionCount /
						1000
					).toFixed(2),
				};
			});

			// Aggregate programming sections into main parent section
			const programmingParentId = "PROGRAMMINGSECTION";
			const progTotalTime = analysis.reduce((acc, curr) => {
				if (
					curr.isProgramming &&
					curr.parentSectionId === programmingParentId
				) {
					return acc + (curr.totalTimeMs || 0);
				}
				return acc;
			}, 0);

			if (progTotalTime > 0) {
				// Check if parent already exists in analysis (it might not if only children were tracked)
				const parentIndex = analysis.findIndex(
					(a) => a.sectionID === programmingParentId && !a.isProgramming
				);

				if (parentIndex !== -1) {
					// Update existing
					analysis[parentIndex].totalTimeMs += progTotalTime;
					analysis[parentIndex].totalTimeSeconds = (
						analysis[parentIndex].totalTimeMs / 1000
					).toFixed(2);
					// Re-calculate average if needed, or leave as is if parent question count includes children
				} else {
					// Create parent entry
					analysis.push({
						sectionID: programmingParentId,
						sectionName: "Programming Section (Total)",
						totalTimeMs: progTotalTime,
						totalTimeSeconds: (progTotalTime / 1000).toFixed(2),
						// Avg per question is tricky without total question count for parent, default null or 0 ?
						// Assuming we just want total time for now.
						avgTimePerQuestionMs: 0,
						avgTimePerQuestionSeconds: "0.00",
					});
				}
			}

			return analysis;
		},
	},
};
</script>

<style scoped>
#monitor-toaster {
	position: fixed;
	top: 1rem;
	right: 1rem;
}
.finish-test-loader {
	position: relative;
	left: 27px;
}
.close-notify {
	background: white;
	border-radius: 50px;
}
.notification {
	position: fixed;
	top: 10px;
	right: 120px;
	border-radius: 5px;
	width: 400px;
	height: 35px;
	background: #4c78ce;
	text-align: center;
}
.notify-green-class {
	background-color: #269c32;
	font-family: "Poppins", sans-serif;
	font-weight: 600;
	font-size: 13px;
	color: #ffffff;
}
.notify-red-class {
	background-color: #eb0002;
	font-family: "Poppins", sans-serif;
	font-weight: 600;
	font-size: 13px;
	color: #ffffff;
}
.notify-yellow-class {
	background-color: yellow;
	font-family: "Poppins", sans-serif;
	font-weight: 600;
	font-size: 13px;
	color: #ffffff;
}
.notify-orange-class {
	background-color: #ffc145;
	font-family: "Poppins", sans-serif;
	font-weight: 600;
	font-size: 13px;
	color: #ffffff;
}
@media only screen and (max-width: 820px) {
	.screenSizeLap {
		display: none;
	}
}

@media only screen and (min-width: 821px) {
	.screenSizeMobile {
		display: none;
	}
}

#proctor {
	height: 15%;
	width: 15%;
	visibility: hidden;
	position: absolute;
	top: 1%;
}
.testscreen-custom-modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(
		0,
		0,
		0,
		0.5
	); /* Semi-transparent background overlay */
	z-index: 1500;
}

.testscreen-modal-content {
	background-color: #fff;
	border: 1px solid #ccc;
	border-radius: 14px;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
	max-width: 50%;
	max-height: 80%;
	overflow: auto;
	padding: 10px;
	position: relative;
	width: 470px;
}
.testscreen-modal-content-2 {
	background-color: #fff;
	border: 1px solid #ccc;
	border-radius: 14px;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
	max-width: 50%;
	max-height: 80%;
	overflow: auto;
	padding: 10px;
	position: relative;
	width: 572px;
	height: 370px;
}

.modal-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px;
	background-color: #007bff;
	color: #fff;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.modal-title {
	margin: 0;
}

.close {
	background: none;
	border: none;
	font-size: 24px;
	color: #fff;
	cursor: pointer;
	outline: none;
}

.modal-body {
	padding: 20px;
}

.modal-footer {
	display: flex;
	justify-content: flex-end;
	padding: 10px;
	background-color: #f8f9fa;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
}
/* internet disconnect design */
.internet-disconnected-modal-content {
	border-radius: 18.743px;
	background: #fff;
	box-shadow: 0px 20.08215px 40.1643px 0px rgba(122, 122, 122, 0.2);
	width: 599.303px;
	height: fit-content;
	overflow: auto;
	padding: 12px;
	position: relative;
}

.pagination-icon .btn:focus,
.btn.focus {
	outline: 0;
	box-shadow: none !important;
}

.pagination-icon .btn:not(:disabled):not(.disabled) {
	cursor: pointer;
	box-shadow: none !important;
}

.testscreen-modal-content-camacc {
	background-color: #fff;
	border: 1px solid #ccc;
	border-radius: 14px;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
	/* max-width: 50%; */
	/* max-height: 80%; */
	/* overflow: auto; */
	padding: 10px;
	position: relative;
	width: 650px;
}
.modalcloseicon-camacc {
	position: absolute;
	top: 12px;
	right: 15px;
}
.testscreen-modal-content-installagent {
	background-color: #fff;
	border: 1px solid #ccc;
	border-radius: 14px;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
	max-width: 56%;
	/* max-height: 80%; */
	/* overflow: auto; */
	padding: 28px;
	position: relative;
	/* width: 650px; */
}
.editor-height {
	height: calc(100vh - 100px);
}
.loader-text {
	color: #3a3c40;
	font-size: 16px;
	font-weight: 500;
	font-family: "Lato";
}
.loader-text-2 {
	color: #7a7a7a;
	font-size: 14px;
	font-weight: 500;
	font-family: "Lato", sans-serif;
	position: absolute;
	top: 66%;
}
.video-card {
	height: 315px;
	width: 562px;
	background: #000; /* for contrast */
	overflow: hidden;
	position: relative;
	/* margin: auto; */
	border-radius: 5px;
}
.video-card video {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
	transform: scaleX(-1);
}
.screen-box video {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
	transform: scaleX(-1);
}
.wa-recorder {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 15px;
	font-family: system-ui, sans-serif;
}

.controls {
	display: flex;
	align-items: center;
	gap: 10px;
}

.audio-bar {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	width: 614px;
	background: #20639b14;
	border-radius: 100px;
	padding: 7px 20px;
	height: 72px;
}

.proctoring-main {
	border-radius: 5px;
	background: #ffffff;
	margin: 30px;
	border: 1px solid #e0e0e0;
}

.screen-box {
	border-radius: 5px;
	box-shadow: 0px 3.43px 12.87px 0px #c4c4c480;
	width: 474px;
	height: 267px;
	overflow: hidden;
	position: relative;
	background: #000;
}
.stream-preview-dock {
	position: fixed;
	bottom: 16px;
	left: 16px;
	z-index: 1200;
	display: flex;
	align-items: center;
	transition: transform 0.25s ease;
}
.stream-preview-collapsed {
	transform: translateX(-256px);
}
.stream-preview {
	width: 240px;
	height: 144px;
}
.stream-preview video {
	pointer-events: none;
}
.stream-preview-tab {
	padding: 15px 10px 10px 10px;
	border-radius: 0 10px 10px 0;
	background: #383838;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	height: 101px;
	widows: 37px;
	cursor: pointer;
}
.stream-preview-tab-text {
	writing-mode: vertical-rl;
	text-orientation: mixed;
	transform: rotate(180deg);
	font-family: "Montserrat", sans-serif;
	color: #ffffff;
	font-size: 11px;
	font-weight: 600;
}
.stream-preview-tab-collapsed {
	padding: 15px 10px 10px 10px;
	border-radius: 0 10px 10px 0;
	background: #383838;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 101px;
	widows: 37px;
	cursor: pointer;
}
.stream-collapse-icon {
	width: 12px;
	height: 12px;
	transform: rotate(180deg);
}
.stream-preview-dot {
	width: 14px;
	height: 14px;
}
.question-box {
	padding: 15px;
	border-radius: 8px;
	background: #ffffff;
	border: 1px solid #8c8c8c54;
}

.question-img {
	width: 225px;
	border-radius: 4px;
	height: 190px;
	background: #20639b1a;
}

.question-img img {
	width: 100%;
	height: 100%;
}

.main-question-box {
	width: 80%;
	display: flex;
	padding-top: 50px;
	flex-direction: column;
	margin: 0 auto;
}
.margin4416px {
	margin: 44px 0 16px 0px;
}
.mt-44 {
	margin-top: 44px;
}
</style>
